// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___1ZO5k","empty":"styles__empty___P5bb_","attach":"styles__attach___1_VDJ"};